import React from "react";
import testData from "../testData/blogData.json";
import filterMap from "./SetFilterTags";
import "../scss/_miniBlogPosts.scss";
//import ThermalPenImage from "../assets/ThermalPenImage.jpg";
//import HCI4GoodLogo from "../assets/HCI4GOODLOGO_square_ready.png";

//const imageMap = {
//    "ThermalPenImage.jpg": ThermalPenImage,
//    "HCI4GOODLOGO_square_ready.png": HCI4GoodLogo
//};


const DisplayedResearchPosts = ({ currentFilter, results }) => {

    const hasSearchResults = results == "" ? false : true;
    const searchResults = results;
    const tagFiltered = currentFilter !== "All";
    let finalFilter = testData;

    if (!hasSearchResults && !tagFiltered) {
        finalFilter = testData;
    }
    if (hasSearchResults && !tagFiltered) {
        finalFilter = searchResults;
    }
    if (!hasSearchResults && tagFiltered) {
        finalFilter = testData.filter(filterMap[currentFilter]);
    }
    if (hasSearchResults && tagFiltered) {
        finalFilter = searchResults.filter(filterMap[currentFilter])
    }

    return (
        <div
            className="blogPostsContainer"
            style={{
                justifyContent:
                    currentFilter != "All" ? "left" : "space-between",
            }}
        >
            {finalFilter.map((item, i) => (
                <div
                    key={i}
                    className="blogPost"
                    style={{
                        margin: currentFilter != "All" ? "0 2.1vw 0 0" : "0",
                    }}
                >
                    <img src={item.image} alt={item.alt} style={{ width: "600px", height: "400px", objectFit: "cover", display: "block" }} />
                    <div className="textContainer">
                        <div className="date">{item.date}</div>
                        <div className="title">{item.title}</div>
                        <div className="description">{item.description}</div>
                    </div>
                    {getTags(item.tag)}
                </div>
            ))}
        </div>
    );
};

const getTags = (tagArray) => {
    return (
        <div className="tags">
            {tagArray.map((tag, index) => (
                <div className="tagContainer" key={index}>
                    <div className="tag">{tag}</div>
                </div>
            ))}
        </div>
    );
};

export default DisplayedResearchPosts;
